import { Grid } from 'common/layouts/grid/Grid';
import { GridColumn } from 'common/layouts/grid/GridColumn';
import { Flex } from 'component-library/components/layout/Flex';
import { Link } from 'component-library/components/links/Link';
import { Body } from 'component-library/components/typography/Body';
import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import React, { FC } from 'react';
import styled from 'styled-components';

import { FooterProps, FooterTemplate } from '.';
import { FAQs } from './FAQs';
import { Legal } from './Legal';
import { Links } from './Links';
import { Socials } from './Socials';

const Accreditations = styled(Flex)`
  border-top: 1px solid rgba(38, 49, 59, 0.12);
  padding-top: 48px;

  svg {
    margin-right: 16px;
  }
`;

const StyledLegal = styled(Legal)<FooterProps>`
  flex-basis: ${({ template }) =>
    template === FooterTemplate.Full ? '66%' : '100%'};
  margin-right: 4%;
`;

const FooterWrapper = styled(ShowOn)`
  max-width: 1568px;
  margin: 0 auto;
  padding: 40px;
  border-top: 1px solid rgba(38, 49, 59, 0.12);
`;

export const FooterLarge: FC<FooterProps> = ({
  template,
  displayDepositAccountDetails,
  additionalFootnotes = [],
}) => {
  const isFull = template === FooterTemplate.Full;
  const isLegalDisclaimerOnly = template === FooterTemplate.LegalDisclaimerOnly;
  const isLegalDisclaimerAndContacts =
    template === FooterTemplate.LegalDisclaimerAndContacts;

  return (
    <FooterWrapper screens={[Screen.Lg, Screen.Xl, Screen.Xxl]}>
      <Grid cols={8}>
        {!isLegalDisclaimerOnly && (
          <GridColumn span={2}>
            <Socials />
          </GridColumn>
        )}
        {!isLegalDisclaimerOnly && (
          <GridColumn span={isLegalDisclaimerAndContacts ? 2 : 5}>
            <Links contactOnly={isLegalDisclaimerAndContacts} />
          </GridColumn>
        )}
        <GridColumn span={isLegalDisclaimerOnly ? 8 : 4}>
          <StyledLegal
            template={template}
            displayDepositAccountDetails={displayDepositAccountDetails}
            additionalFootnotes={additionalFootnotes}
          />
        </GridColumn>
        {isFull && (
          <GridColumn span={3}>
            <FAQs />
          </GridColumn>
        )}
      </Grid>
      <Accreditations justifyContent="space-between">
        <Body variant={5}>© 2024 Retirable Inc. All rights reserved.</Body>
        <Flex>
          <Link to="/legal/terms-and-conditions" marginRight={48} variant={5}>
            Terms and Conditions
          </Link>
          <Link to="/legal/privacy-policy" variant={5}>
            Privacy Policy
          </Link>
        </Flex>
      </Accreditations>
    </FooterWrapper>
  );
};
